var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"cd-logo"},[_vm._v("cargo"),_c('span',{staticClass:"cd-logo__red-square"},[_vm._v("▄")]),_vm._v("direct")])}]

export { render, staticRenderFns }